// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_io-0";
export var fileCarousel = "_io-2";
export var removeFileButton = "_io-1";